import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import SupplierEditData from "../../../components/SupplierEdit/SupplierEditData";
import SupplierFormData from "../../../components/SupplierInformationData/SupplierFormData";
// import "../../.././assets/css/customize.css";
import PayBillsEditData from "../../../components/SupplierPayBillsEditData/PayBillsEditData";
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from "../../../common/Constant";
import { toastError, toastSuccess } from "../../../common/Toast";
import config from "../../../config/config";
import axios from "axios";
import SupplierStatement from "../../../components/Supplier/SupplierStatement";

const ManageSuppliers = () => {
  const [loading, setLoading] = useState(false);
  const [supplier, setSupplier] = useState(true);
  const [receivingListId, setReceivingListId] = useState();
  const [receivingData, setReceivingData] = useState(false);
  const [payBillsData, setPayBillsData] = useState(false);
  const [comment, setComment] = useState(false);
  const [internalnotes, setInternalNotes] = useState(false);
  const [contenttype, setContentType] = useState("");
  const [content, setContent] = useState("");
  const [supplierdetails, setSupplierDetails] = useState({});
  const [statement, setStatement] = useState(false);
  const [showErrorOfLength, setShowErrorOfLength] = useState(false);
  const [showErrorOfLengthNote, setShowErrorOfLengthNote] = useState(false);

  const paramObject = useParams();
  let ID = paramObject.id;
  const navigate = useNavigate();

  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");

  const handleStatement = () => {
    setStatement(true);
    setInternalNotes(false);
    setComment(false);
    setSupplier(false);
    setPayBillsData(false);
    setReceivingData(false);
  };

  const handleToggle = (id) => {
    setStatement(false);
    setSupplier(false);
    setPayBillsData(false);
    setReceivingListId(id);
    setReceivingData(true);
    setInternalNotes(false);
    setComment(false);
  };

  const handleComment = () => {
    setStatement(false);
    setComment(true);
    setSupplier(false);
    setPayBillsData(false);
    setReceivingData(false);
    setInternalNotes(false);
  };

  const handleNotes = () => {
    setInternalNotes(true);
    setStatement(false);
    setComment(false);
    setSupplier(false);
    setPayBillsData(false);
    setReceivingData(false);
  };

  const handleClick = () => {
    setSupplier(false);
    setStatement(false);
    setReceivingData(false);
    setPayBillsData(true);
    setComment(false);
    setInternalNotes(false);
  };

  const handleCommentAndNotes = (e) => {
    console.log(e.target.name, "length of comment");
    if (e.target.value.length >= 255) {
      e.target.name == "COMMENTS"
        ? setShowErrorOfLength(true)
        : e.target.name == "NOTES" && setShowErrorOfLengthNote(true);
    } else {
      setShowErrorOfLength(false);
      setShowErrorOfLengthNote(false);
      setContentType(e.target.name);
      setContent(e.target.value);
    }
  };

  // console.log("params_id:---", ID);

  const commentandnotes = {
    id: ID,
    content: content,
    contenttype: contenttype,
    loginuserid: Id,
  };

  console.log(commentandnotes);

  useEffect(() => {
    // Binding Customer Fields

    setLoading(true);

    axios
      .get(`${config.suppliersBaseUrl}/suppliers/findbyid?id=${ID}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("Response:------------121", res.data.ResponseData);
        setSupplierDetails(res.data.ResponseData.Items[0]);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const handleSubmit1 = () => {
    // console.log( "sonu")
    axios
      .post(
        `${config.suppliersBaseUrl}/suppliers/updatecomments`,
        commentandnotes,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          // navigate("/customers");
          navigate(-1);
        } else if (res.data.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);

        // backtopreviouspage();
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  console.log(supplierdetails, "supplierdetails 162");

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
        <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
          <div className="row " style={{ marginTop: "5px" }}>
            {/* <div className="col"> */}
              <h3 className="page-title">Supplier</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item"  >
                  <Link to="/suppliers">Suppliers List</Link>
                </li>
                <li className="breadcrumb-item active">Manage Supplier</li>
              </ul>
            {/* </div> */}
          </div>
        </div>

          {paramObject.id > 0 && (
            <div
              style={{
                padding: "10px",
                display: "flex",
                columnGap: "21px",
                marginBottom: "15px",
              }}
            >
              <div
                style={{
                  border: "1px solid rgba(107, 108, 114, 0.61)",
                  padding: "20px",
                  borderRadius: "4px",
                  boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px",
                  width: "78%",
                  backgroundColor: "white",
                }}
              >
                <h2>{supplierdetails?.CompanyName}</h2>
                <p
                  style={{
                    marginBottom: "0",
                    fontSize: "large",
                    paddingLeft: "12px",
                  }}
                >
                  {supplierdetails?.Address1} {supplierdetails?.Address2}
                </p>
                <p
                  style={{
                    marginBottom: "0",
                    fontSize: "large",
                    paddingLeft: "12px",
                  }}
                >
                  {supplierdetails?.City +
                    ", " +
                    supplierdetails?.State +
                    ", " +
                    supplierdetails?.Country}
                </p>
                <p
                  style={{
                    marginBottom: "0",
                    fontSize: "large",
                    paddingLeft: "12px",
                  }}
                >
                  {supplierdetails?.Zip}
                </p>
              </div>
              <div
                style={{
                  border: "1px solid rgba(107, 108, 114, 0.61)",
                  padding: "20px",
                  borderRadius: "4px",
                  boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px",
                  width: "20%",
                  backgroundColor: "white",
                }}
              >
                <h3 style={{ fontweight: "600" }}>SUMMARY</h3>
                <div>
                  <h3
                    style={{
                      paddingLeft: "10px",
                      borderLeft: "5px solid rgb(255, 202, 0)",
                    }}
                  >
                    ${parseFloat(supplierdetails?.Balance).toFixed(2)}
                  </h3>
                  <p
                    style={{
                      marginBottom: "10px",
                      color: "rgb(0, 0, 0)",
                      fontSize: "initial",
                      lineHeight: "20px",
                      marginLeft: "15px",
                    }}
                  >
                    {/* Open balance */}
                    Supplier Wallet Balance
                  </p>
                </div>
                <div>
                  <h3
                    style={{
                      paddingLeft: "10px",
                      borderLeft: "5px solid rgb(228, 56, 52)",
                    }}
                  >
                    {supplierdetails?.OverduePayment == null
                      ? `$${parseFloat(0).toFixed(2)}`
                      : `$${parseFloat(supplierdetails?.OverduePayment).toFixed(
                          2
                        )}`}
                  </h3>
                  <p
                    style={{
                      color: "rgb(0, 0, 0)",
                      fontSize: "initial",
                      lineHeight: "20px",
                      marginLeft: "15px",
                    }}
                  >
                    Overdue payment
                  </p>
                </div>
              </div>
            </div>
          )}

          {ID === undefined ? (
            <div>{<SupplierFormData />}</div>
          ) : (
            <div className="row">
              <div className="col-lg-2 col-md-9">
                <ul className="inbox-menu nav nav-pills">
                  <li
                    className="nav-item"
                    onClick={() => {
                      setSupplier(true);
                      setStatement(false);
                      setReceivingData(false);
                      setPayBillsData(false);
                      setComment(false);
                      setInternalNotes(false);
                    }}
                  >
                    <a
                      className="nav-link active"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-user" aria-hidden="true"></i>
                      <span>Supplier Information</span>
                    </a>
                  </li>
                  <li className="nav-item" onClick={() => handleToggle(4)}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-check" aria-hidden="true"></i>
                      <span>Transaction</span>
                    </a>
                  </li>
                  {/* <li className="nav-item" onClick={() => handleToggle(2)}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-check" aria-hidden="true"></i>
                      <span>Receiving</span>
                    </a>
                  </li> */}
                  {/* <li className="nav-item" onClick={() => handleToggle(7)}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-check" aria-hidden="true"></i>
                      <span>Expense</span>
                    </a>
                  </li> */}
                  {/* <li className="nav-item" onClick={() => handleToggle(1)}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-first-order" aria-hidden="true"></i>
                      <span>Purchase Order</span>
                    </a>
                  </li> */}
                  {/* <li className="nav-item" onClick={() => handleToggle(5)}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-solid fa-credit-card"></i>
                      <span>Vendor Credit</span>
                    </a>
                  </li> */}
                  {/* <li className="nav-item" onClick={() => handleToggle(3)}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-solid fa-credit-card"></i>
                      <span>Supplier Return</span>
                    </a>
                  </li> */}
                  <li className="nav-item" onClick={() => handleToggle(6)}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-folder-open" aria-hidden="true"></i>
                      <span>Wallet Logs</span>
                    </a>
                  </li>
                  <li className="nav-item" onClick={() => handleClick()}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-solid fa-money-bill"></i>
                      <span>Paid Bills</span>
                    </a>
                  </li>
                  <li className="nav-item" onClick={() => handleStatement()}>
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      role="tab"
                      href="javascript:void(0);"
                    >
                      <i className="fa fa-solid fa-money-bill"></i>
                      <span>Statement</span>
                    </a>
                  </li>
                  <li class="nav-item" onClick={handleComment}>
                    <a
                      class="nav-link"
                      href="javascript:void(0);"
                      data-bs-toggle="pill"
                      role="tab"
                    >
                      <i class="fa fa-comment-o" aria-hidden="true"></i>
                      <span id="cust">Comments</span>
                    </a>
                  </li>
                  <li class="nav-item" onClick={handleNotes}>
                    <a
                      class="nav-link"
                      href="javascript:void(0);"
                      data-bs-toggle="pill"
                      role="tab"
                    >
                      <i class="fa fa-sticky-note-o" aria-hidden="true"></i>
                      <span id="cust">Internal Notes</span>
                    </a>
                  </li>
                </ul>
              </div>

              {comment ? (
                <div className="col-lg-10 col-md-12">
                  <div className="card bg-white">
                    {/* <div className="row m-3"> */}
                    {/* <div className="col-sm-12"> */}
                    <div className="form-group col">
                      <label className="col-form-label col-md-8 form-label">
                        Comments
                      </label>
                      <div className="col-md-12">
                        {showErrorOfLength && (
                          <p style={{ color: "red" }}>
                            *Comment Character Count Exceeds 255 Characters
                          </p>
                        )}
                        <textarea
                          as="textarea"
                          maxLength={255}
                          className="form-control h-100 w-100"
                          // id="exampleFormControlTextarea1"
                          rows="10"
                          defaultValue={supplierdetails.Comments}
                          onChange={handleCommentAndNotes}
                          id="Comments"
                          name="COMMENTS"
                        />
                      </div>
                    </div>
                    {/* </div> */}

                    {/* </div> */}
                  </div>

                  <div>
                    <div className="pull-right ">
                      <button
                        onClick={handleSubmit1}
                        className="btn btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                      <div
                        onClick={() => navigate(-1)}
                        // className="btn btn-secondary mb-3 pr-3"
                        className="btn btn-dark btn-md me-1 pull-right"
                      >
                        Cancel
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {internalnotes ? (
                <div className="col-lg-10 col-md-12">
                  <div className="card bg-white">
                    {/* <div className="row m-3">
<div className="col-sm-12"> */}
                    <div className="form-group col">
                      <label className="col-form-label col-md-8 form-label">
                        Internal Notes
                      </label>
                      <div className="col-md-12 ">
                        {showErrorOfLengthNote && (
                          <p style={{ color: "red" }}>
                            *Note Character Count Exceeds 255 Characters
                          </p>
                        )}
                        <textarea
                          as="textarea"
                          className="form-control h-100 w-100"
                          maxLength={255}
                          // onChange={handleChange}
                          onChange={handleCommentAndNotes}
                          id="InternalNotes"
                          defaultValue={supplierdetails.Internalnotes}
                          // name="InternalNotes"
                          rows="10"
                          name="NOTES"
                        />
                      </div>
                    </div>
                  </div>
                  {/* </div>
</div> */}

                  <div>
                    <div className="pull-right ">
                      <button
                        // type="submit"
                        onClick={handleSubmit1}
                        className="btn btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                      <div
                        // onClick={backtopreviouspage}
                        onClick={() => navigate(-1)}
                        className="btn btn-dark btn-md me-1 pull-right "
                      >
                        Cancel
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {supplier === true ? <SupplierFormData /> : ""}
              {payBillsData === true ? (
                <PayBillsEditData supplierid={ID} />
              ) : (
                ""
              )}
              {receivingData === true ? (
                <SupplierEditData
                  // receivingTypeID={receivingListId}
                  supplierID={ID}
                  supplierAccount={receivingListId}
                />
              ) : (
                ""
              )}
              {statement === true ? <SupplierStatement /> : ""}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ManageSuppliers;

// {comment ? <><div className="col-lg-10 col-md-12">
// <div className="card bg-white">
// <div className="row m-3">
//                           <div className="col-sm-12">
//                             <div className="form-group row">
//                               <label className="col-form-label col-md-2 form-label">
//                                 Comments
//                               </label>
//                               <div className="col-md-8">
//                                 <textarea
//                                   as="textarea"

//                                   className="form-control h-100 "
//                                   // id="exampleFormControlTextarea1"
//                                   rows="10"
//                                   // onChange={handleChange}
//                                   id="Comments"
//                                   name="Comments"
//                                 />
//                               </div>
//                             </div>
//                           </div>

// </div>
// </div>
// </div> : ""}
// {internalnotes ?  <div className="row m-3">
// <div className="col-sm-12">
//                               <div className="form-group row">
//                                 <label className="col-form-label col-md-2 form-label">
//                                   Internal Notes
//                                 </label>
//                                 <div className="col-md-8 ">
//                                   <textarea
//                                     as="textarea"
//                                     className="form-control h-100"
//                                     // onChange={handleChange}
//                                     id="InternalNotes"
//                                     name="InternalNotes"
//                                     rows="10"
//                                   />
//                                 </div>
//                               </div>
//                             </div>
// </div>: ""}
